<app-generate-course-form-start (moveEvent)="move($event)"></app-generate-course-form-start>
<app-generate-course-form-source (moveEvent)="move($event)"></app-generate-course-form-source>
<app-generate-course-form-wikilinks (moveEvent)="move($event)"></app-generate-course-form-wikilinks>
<app-generate-course-form-pdf (moveEvent)="move($event)"></app-generate-course-form-pdf>